module.exports = __webpack_public_path__ + "img/osve-logo.bc74d94c.png";